import { createApp } from 'vue'
import App from './App.vue'


import "./fonts.css";
import "./global.scss";
import router from './router'
import { initSentry } from './sentry/init'

import { vTooltip } from 'floating-vue'
import { createPinia } from "pinia"

const app = createApp(App);
const pinia = createPinia();

initSentry(app, router);

app.use(pinia);
app.use(router);

app.directive('tooltip', vTooltip);

app.mount('#app')

